import { Link } from "react-router-dom";
import servicesOneData from "./servicesOneData";

const ServicesOne = () => {
    return (
        <section className="our-service-wrapper section-padding bg-gray">
        <div className="container">
            <div className="row mtm-30">
                <div className="col-md-6 col-12 col-lg-4 mt-30 align-self-start">
                    <div className="block-contents">
                        <div className="section-title">
                            <span>Featured Service</span>
                            <h2>What We Offer You</h2>
                        </div>
                        <p>Our promise as a contractor is to build strong community value into every projects</p>
                    </div>
                </div>
                {
                    servicesOneData.map((data) => (
                        <div className="col-md-6 col-12 col-lg-4 mt-30 d-flex" key={data.id}>
                            <div className="single-service-box style-1 d-flex flex-column flex-grow-1 w-100">
                                <div className="service-bg bg-cover flex-shrink-0" style={{backgroundImage: `url(${data.bg})`}}></div>
                                <div className="icon flex-shrink-0">
                                    <img src={data.icon} alt={data.title} />
                                </div>
                                <div className="contents flex-grow-1 d-flex flex-column">
                                    <h4>{data.title}</h4>
                                    <p className="mb-0 flex-grow-1">{data.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    </section>
    )
}

export default ServicesOne;